// ERX section titles
export const ERXComponentsHeader = {
  UPLOAD_MANUAL_PRESCRIPTION: "Upload Manual Prescription",
  SAVED_AND_SHARED_PRESCRIPTIONS: "Saved & Shared Prescriptions",
  PATIENT_DETAILS: "Patient Details",
  OBSTETRIC_CALCULATOR: "Obstetric Calculator",
  VITALS: "Vitals",
  PATIENT_HISTORY_AND_COMPLAINTS: "Patient History & Complaints",
  DIAGNOSIS: "Diagnosis",
  PATIENT_OR_REPORTS_EXAMINATION: "Patient/Reports Examination",
  FILES: "Files",
  DRUG_OR_MEDICINES: "Drug/Medicines",
  PATIENT_FOLLOWUP: "Patient Follow-Up",
  DOCTOR_NOTES: "Doctor Notes",
  VACCINE_CHART: "Vaccine Chart",
  GROWTH_CHART: "Charts",
  SUGGESTED_INVESTIGATION: "Suggested Investigation & Instructions",
  CUSTOM_SECTION1: "Custom Section1",
  CUSTOM_SECTION2: "Custom Section2",
  CUSTOM_SECTION3: "Custom Section3",
};

// ERX section labels used for settings (expand/collapse, dragged position and so on)
export const SELECTION_LIST_TITLES = {
  PATIENT_DETAILS: "PatientDetails",
  VITALS: "Vitals",
  PATIENT_HISTORY: "PatientHistory",
  DIAGNOSIS: "Diagnosis",
  PATIENT_EXAMINATION: "PatientExamination",
  FILES: "Files",
  DRUG_MEDICINE: "DrugMedicine",
  PATIENT_FOLLOW_UP: "PatientFollow-up",
  VACCINE_CHART: "VaccineChart",
  CUSTOM_SECTION1: "CustomSection1",
  CUSTOM_SECTION2: "CustomSection2",
  CUSTOM_SECTION3: "CustomSection3",
  MANUAL_PRESCRIPTION: "ManualPrescription",
  SAVED_SHARED_ERX: "SavedSharedErx",
  DOCTOR_NOTES: "DoctorNotes",
  GROWTH_CHART: "GrowthChart",
  SUGGESTED_INVESTIGATION: "SuggestedInvestigation",
  OBSTETRIC_HISTORY: "ObstetricHistory",
  OBSTETRIC_CALCULATOR: "ObstetricCalculator",
};

export const SECTIONAL_TEMPLATES = {
  SUGGESTED_INVESTIGATION_TEMPLATE: "S. Investigation Templates",
  DIAGNOSIS_TEMPLATE: "Diagnosis templates",
  DRUG_TEMPLATE: "Drug templates",
};

export const SELECTED_TAB_LIST = {
  HOME: "home",
  FILES: "files",
  VACCINE_CHART: "vaccine chart",
  GROWTH_CHART: "growth chart",
  PRESCRIPTION: "prescription",
};

// constant for ERX section details
export const ERXComponents = [
  {
    id: 3,
    title: ERXComponentsHeader.VITALS,
    name: SELECTION_LIST_TITLES.VITALS,
    expand: false,
    show: true,
    position: 3,
    settings: [
      {
        question: "Want to print vitals on prescription?",
        answer: true,
        que_key: "includeInErx",
      },
      {
        question: "Wanted to see previous vitals of the patient?",
        answer: true,
        que_key: "hidePastVitals",
      },
    ],
    showInDetails: true,
    hasInputs: true,
    draggable: true,
    showSettings: true,
  },
  {
    id: 4,
    title: ERXComponentsHeader.PATIENT_HISTORY_AND_COMPLAINTS,
    name: SELECTION_LIST_TITLES.PATIENT_HISTORY,
    expand: false,
    show: true,
    position: 4,
    settings: [
      {
        question: "Medical History",
        answer: true,
        que_key: "past_medical_history",
      },
      {
        question: "Menstrual History",
        answer: true,
        que_key: "menstrual_history",
      },
      {
        question: "Obstetric History",
        answer: true,
        que_key: "obstetric_history",
      },
      {
        question: "Family History",
        answer: true,
        que_key: "family_history",
      },
      {
        question: "LifeStyle History",
        answer: true,
        que_key: "lifestyle_history",
      },
    ],
    showInDetails: true,
    hasInputs: true,
    draggable: true,
    showSettings: true,
  },
  {
    id: 5,
    title: ERXComponentsHeader.DIAGNOSIS,
    name: SELECTION_LIST_TITLES.DIAGNOSIS,
    expand: true,
    show: true,
    position: 5,
    settings: [
      {
        question: "Want to print diagnosis on prescription?",
        answer: true,
        que_key: "includeInErx",
      },
    ],
    showInDetails: true,
    hasInputs: true,
    draggable: true,
    showSettings: true,
    templateTitle: SECTIONAL_TEMPLATES.DIAGNOSIS_TEMPLATE,
    templateSearchPlaceholder: "Search Diagnosis Template",
    inputPlaceholder: "Diagnosis Template Name",
  },
  {
    id: 6,
    title: ERXComponentsHeader.PATIENT_OR_REPORTS_EXAMINATION,
    name: SELECTION_LIST_TITLES.PATIENT_EXAMINATION,
    expand: true,
    show: true,
    position: 6,
    settings: [
      {
        question: "Want to print reports/examinations on prescription?",
        answer: true,
        que_key: "includeInErx",
      },
    ],
    showInDetails: true,
    hasInputs: true,
    draggable: true,
    showSettings: true,
  },
  {
    id: 8,
    title: ERXComponentsHeader.DRUG_OR_MEDICINES,
    name: SELECTION_LIST_TITLES.DRUG_MEDICINE,
    expand: false,
    show: true,
    position: 8,
    showInDetails: true,
    hasInputs: true,
    draggable: true,
    templateTitle: SECTIONAL_TEMPLATES.DRUG_TEMPLATE,
    templateSearchPlaceholder: "Search Drug Template",
    inputPlaceholder: "Drug Template Name",
  },
  {
    id: 9,
    title: ERXComponentsHeader.PATIENT_FOLLOWUP,
    name: SELECTION_LIST_TITLES.PATIENT_FOLLOW_UP,
    expand: false,
    show: true,
    position: 9,
    showInDetails: true,
    hasInputs: false,
    draggable: true,
  },
  {
    id: 10,
    title: ERXComponentsHeader.SUGGESTED_INVESTIGATION,
    name: SELECTION_LIST_TITLES.SUGGESTED_INVESTIGATION,
    expand: false,
    show: true,
    position: 10,
    showInDetails: true,
    hasInputs: true,
    draggable: true,
    templateTitle: SECTIONAL_TEMPLATES.SUGGESTED_INVESTIGATION_TEMPLATE,
    templateSearchPlaceholder: "Search Investigation Template",
    inputPlaceholder: "Investigation Template Name",
  },
  {
    id: 11,
    title: ERXComponentsHeader.DOCTOR_NOTES,
    name: SELECTION_LIST_TITLES.DOCTOR_NOTES,
    expand: false,
    show: true,
    position: 11,
    showInDetails: true,
    hasInputs: true,
    draggable: true,
  },
  {
    id: 13,
    title: ERXComponentsHeader.CUSTOM_SECTION1,
    name: SELECTION_LIST_TITLES.CUSTOM_SECTION1,
    expand: false,
    show: false,
    position: 13,
    showInDetails: true,
    hasInputs: false,
    draggable: true,
  },
  {
    id: 14,
    title: ERXComponentsHeader.CUSTOM_SECTION2,
    name: SELECTION_LIST_TITLES.CUSTOM_SECTION2,
    expand: false,
    show: false,
    position: 14,
    showInDetails: true,
    hasInputs: false,
    draggable: true,
  },
  {
    id: 15,
    title: ERXComponentsHeader.CUSTOM_SECTION3,
    name: SELECTION_LIST_TITLES.CUSTOM_SECTION3,
    expand: false,
    show: false,
    position: 15,
    showInDetails: true,
    hasInputs: false,
    draggable: true,
  },
  {
    id: 16,
    title: ERXComponentsHeader.GROWTH_CHART,
    name: SELECTION_LIST_TITLES.GROWTH_CHART,
    expand: false,
    show: true,
    position: 16,
    settings: [
      {
        question: "Want to print Weight-for-length Chart?",
        answer: false,
        que_key: "weight-for-length",
      },
      {
        question: "Want to print Weight-for-Age Chart?",
        answer: false,
        que_key: "weight-for-age",
      },
      {
        question: "Want to print BMI-for-Age Chart?",
        answer: false,
        que_key: "bmi-for-age",
      },
      {
        question: "Want to print HC-for-Age Chart?",
        answer: false,
        que_key: "hc-for-age",
      },
      {
        question: "Want to print MUAC-for-Age Chart?",
        answer: false,
        que_key: "muac-for-age",
      },

      {
        question: "Want to print Length-for-Age Chart?",
        answer: false,
        que_key: "length-for-age",
      },
    ],
  },
  {
    id: 17,
    title: ERXComponentsHeader.OBSTETRIC_CALCULATOR,
    name: SELECTION_LIST_TITLES.OBSTETRIC_CALCULATOR,
    expand: false,
    show: true,
    position: 17,
    settings: [
      {
        question: "Want to print Obstetric Calculator on Prescription?",
        answer: true,
        que_key: "includeInErx",
      },
    ],
    showInDetails: true,
    hasInputs: true,
    draggable: true,
    showSettings: true,
  },
];

// constant for gender options
export const GENDER_MENU_OPTIONS = [
  { id: 1, label: "Female", value: "female", selected: false },
  { id: 2, label: "Male", value: "male", selected: false },
  { id: 3, label: "Others", value: "others", selected: false },
];

// constant list for vitals
export const VITALS_LIST = [
  {
    id: 1,
    name: "Weight",
    value: "",
    unit: "",
    unitList: ["Kg", "Lbs"],
  },
  {
    id: 2,
    name: "Height",
    value: "",
    unit: "",
    unitList: ["cm", "ft’in”"],
  },
  {
    id: 3,
    name: "BMI",
    value: "",
    unit: "Kg/m2",
    unitList: ["Kg/m2"],
    disabled: true,
  },
  {
    id: 4,
    name: "BP Systolic",
    value: "",
    unit: "mmHg",
    unitList: ["mmHg"],
  },
  {
    id: 5,
    name: "BP Diastolic",
    value: "",
    unit: "mmHg",
    unitList: ["mmHg"],
  },
  {
    id: 10,
    name: "Respiration Rate",
    value: "",
    unit: "BPM",
    unitList: ["BPM"],
  },

  {
    id: 7,
    name: "SPO2",
    value: "",
    unit: "%",
    unitList: ["%"],
  },
  {
    id: 9,
    name: "Pulse Rate",
    value: "",
    unit: "BPM",
    unitList: ["BPM"],
  },
  {
    id: 6,
    name: "Temperature",
    value: "",
    unit: "",
    unitList: ["°F", "°C"],
  },
  {
    id: 8,
    name: "Random Glucose",
    value: "",
    unit: "",
    unitList: ["mg/dL", "mmol/L"],
  },
  {
    id: 11,
    name: "LMP",
    value: "",
    unit: "Days",
    unitList: ["Days"],
  },
];

// constant list for follow up
export const FOLLOW_UP_EVENTS = [
  {
    title: "After 7 Days",
    value: 7,
    position: false,
  },
  {
    title: "After 15 Days",
    value: 15,
    position: false,
  },
  {
    title: "After 30 Days",
    value: 30,
    position: false,
  },
  {
    title: "After 90 Days",
    value: 90,
    position: false,
  },
  {
    title: "After 180 Days",
    value: 180,
    position: false,
  },
];

// constant list for add record dropdown
export const ADD_RECORD_LIST = [
  {
    id: 1,
    label: "Vitals",
    value: SELECTION_LIST_TITLES.VITALS,
    selected: true,
  },
  {
    id: 2,
    label: "Patient History",
    value: SELECTION_LIST_TITLES.PATIENT_HISTORY,
    selected: true,
  },
  {
    id: 3,
    label: "Diagnosis",
    value: SELECTION_LIST_TITLES.DIAGNOSIS,
    selected: true,
  },
  {
    id: 4,
    label: "Patient Examination",
    value: SELECTION_LIST_TITLES.PATIENT_EXAMINATION,
    selected: true,
  },
  {
    id: 5,
    label: "Drug / Medicine",
    value: SELECTION_LIST_TITLES.DRUG_MEDICINE,
    selected: true,
  },
  {
    id: 6,
    label: "Suggest Investigations",
    value: SELECTION_LIST_TITLES.SUGGESTED_INVESTIGATION,
    selected: true,
  },
  {
    id: 7,
    label: "Obstetric Calculator",
    value: SELECTION_LIST_TITLES.OBSTETRIC_CALCULATOR,
    selected: true,
  },
];

// constant for patient history and complaints section
export const PATIENT_HISTORY_AND_COMPLAINTS = {
  call_api: false,
  value: [
    {
      id: 1,
      inputLabel: "Chief Complaints",
      name: "chief_complaints",
      options: [],
      value: [],
      pageNo: 1,
      menuIsOpen: false,
      showFor: ["male", "female", "others"],
      hasCustomSaveButton: true,
    },
    {
      id: 2,
      inputLabel: "Medical History",
      name: "past_medical_history",
      options: [],
      value: [],
      pageNo: 1,
      menuIsOpen: false,
      showFor: ["male", "female", "others"],
      hasCustomSaveButton: true,
    },
    {
      id: 3,
      inputLabel: "Family History",
      name: "family_history",
      options: [],
      value: [],
      pageNo: 1,
      menuIsOpen: false,
      showFor: ["male", "female", "others"],
      hasCustomSaveButton: true,
    },
    {
      id: 4,
      inputLabel: "Menstrual History",
      name: "menstrual_history",
      options: [],
      value: [],
      pageNo: 1,
      menuIsOpen: false,
      showFor: ["female"],
      hasCustomSaveButton: true,
    },
    {
      id: 5,
      inputLabel: "Obstetric History",
      name: "obstetric_history",
      options: [],
      value: [],
      pageNo: 1,
      menuIsOpen: false,
      showFor: ["female"],
      hasCustomSaveButton: false,
    },
    {
      id: 6,
      inputLabel: "Lifestyle History",
      name: "lifestyle_history",
      options: [],
      value: [],
      pageNo: 1,
      menuIsOpen: false,
      showFor: ["male", "female", "others"],
      hasCustomSaveButton: true,
    },
  ],
};

// constant for suggested investigation and instruction and notes section
export const FOLLOW_UP_LIST = {
  call_api: false,
  value: [
    {
      id: 1,
      inputLabel: "Suggested Investigation",
      name: "suggested_investigation",
      options: [],
      value: [],
      pageNo: 1,
      menuIsOpen: false,
      hasCustomSaveButton: false,
    },
    {
      id: 2,
      inputLabel: "Instructions and Notes",
      name: "instructions_and_notes",
      options: [],
      value: [],
      pageNo: 1,
      menuIsOpen: false,
      hasCustomSaveButton: true,
    },
  ],
};

// default state of drug list
export const DRUG_LIST = {
  call_api: false,
  updateState: false,
  value: [
    {
      appointment_prescription_id: "",
      drug: "",
      frequency: "",
      duration: "",
      instructions: "",
      drug_master_id: null,
      frequency_extended: { title: "", details: "" },
      deleted_at: null,
      frequencyOptions: [],
      frequencyDetailsOptions: [],
      durationOptions: [],
    },
  ],
};

export const DEBOUNCE_DELAY = 500;

// vital fields in growth chart section
export const NEW_VISIT_LIST = [
  {
    id: 1,
    title: "Date of Visit",
    name: "dov",
    value: "",
    inputType: "normal",
    type: "text",
    disabled: true,
    colSize: "col-lg-4 col-md-4 col-sm-12",
  },
  {
    id: 2,
    title: "Date of Birth",
    name: "dob",
    value: "",
    inputType: "normal",
    type: "text",
    disabled: true,
    colSize: "col-lg-4 col-md-4 col-sm-12",
  },
  {
    id: 3,
    title: "Weight",
    name: "weight",
    value: "",
    inputType: "vital",
    type: "number",
    allowDecimal: true,
    disabled: false,
    colSize: "col-lg-4 col-md-4 col-sm-12",
    unit: "Kg",
    unitList: ["Kg"],
  },
  {
    id: 4,
    title: "Length /Height",
    name: "height",
    value: "",
    inputType: "vital",
    type: "number",
    allowDecimal: true,
    disabled: false,
    colSize: "col-lg-4 col-md-4 col-sm-12",
    unit: "Cm",
    unitList: ["Cm"],
  },
  {
    id: 5,
    title: "BMI",
    name: "bmi",
    value: "",
    inputType: "vital",
    type: "number",
    allowDecimal: true,
    disabled: true,
    colSize: "col-lg-4 col-md-4 col-sm-12",
    unit: "kg/m2",
    unitList: ["kg/m2"],
  },
  {
    id: 6,
    title: "Head circumference",
    name: "head_circumference",
    value: "",
    inputType: "vital",
    type: "number",
    allowDecimal: true,
    disabled: false,
    colSize: "col-lg-4 col-md-4 col-sm-12",
    unit: "Cm",
    unitList: ["Cm"],
    hide: false,
    min: 0,
    max: 110,
    errorMsg: "Minimum value is 0 & maximum limit is 110",
  },
  {
    id: 7,
    title: "MUAC",
    name: "muac",
    value: "",
    inputType: "vital",
    type: "number",
    allowDecimal: true,
    disabled: false,
    colSize: "col-lg-4 col-md-4 col-sm-12",
    unit: "Cm",
    unitList: ["Cm"],
    hide: false,
    min: 0,
    max: 110,
    errorMsg: "Minimum value is 0 & maximum limit is 110",
  },
  {
    id: 8,
    title: "Triceps skinfold",
    name: "triceps",
    value: "",
    inputType: "vital",
    type: "number",
    allowDecimal: true,
    disabled: false,
    colSize: "col-lg-4 col-md-4 col-sm-12",
    unit: "Mm",
    unitList: ["Mm"],
    hide: false,
    min: 0,
    max: 110,
    errorMsg: "Minimum value is 0 & maximum limit is 110",
  },
  {
    id: 9,
    title: "Oedema",
    name: "oedema",
    value: "",
    inputType: "radio",
    disabled: false,
    colSize: "col-lg-4 col-md-4 col-sm-12",
    options: [
      {
        name: "Yes",
        value: "yes",
        selected: false,
      },
      {
        name: "No",
        value: "no",
        selected: false,
      },
    ],
  },
  {
    id: 10,
    title: "Measured",
    name: "measured",
    value: "",
    inputType: "radio",
    disabled: false,
    colSize: "col-lg-4 col-md-4 col-sm-12",
    options: [
      {
        name: "Recumbent",
        value: "recumbent",
        selected: false,
      },
      {
        name: "Standing",
        value: "standing",
        selected: false,
      },
    ],
  },
  {
    id: 11,
    title: "Notes",
    name: "notes",
    value: "",
    inputType: "normal",
    type: "text",
    disabled: false,
    colSize: "col-lg-8 col-md-8 col-sm-12",
    max: 200,
    errorMsg: "Maximum limit is 200 characters",
  },
];

// header list in patient visits(growth chart section)
export const PATIENT_VISITS_HEADER = [
  {
    name: "Date",
    className: "col-2",
  },
  {
    name: "Weight (KG)",
    className: "col-2",
  },
  {
    name: "HEIGHT/LENGTH (CM)",
    className: "col-3",
  },
  {
    name: "MEASURED",
    className: "col-2",
  },
  {
    name: "BMI",
    className: "col-1",
  },
  {
    name: "HC(CM)",
    className: "col-1",
  },
];

export const GROWTH_CHART_PAGE_SIZE = 5;

// titles for growth chart tiles
export const GROWTH_CHART_TILES_TITLES = {
  WEIGHT_FOR_LENGTH: "Weight-for-length",
  WEIGHT_FOR_AGE: "Weight-for-Age",
  BMI_FOR_AGE: "BMI-for-Age",
  HC_FOR_AGE: "HC-for-Age",
  MUAC_FOR_AGE: "MUAC-for-Age",
  LENGTH_FOR_AGE: "Length-for-Age",
};

// list of growth chart tiles
export const GROWTH_CHART_TILES = [
  {
    id: 1,
    title: GROWTH_CHART_TILES_TITLES.WEIGHT_FOR_LENGTH,
    subtitle: "Z-Score: ",
    yText: "Weight (Kg)",
    xText: "Length/Height (cm)",
    xData: "height",
    yData: "weight",
    xSteps: 5,
    ySteps: 2,
    selected: true,
    zScore: "",
    show: true,
  },
  {
    id: 2,
    title: GROWTH_CHART_TILES_TITLES.WEIGHT_FOR_AGE,
    subtitle: "Z-Score: ",
    yText: "Weight (Kg)",
    xText: "Age",
    xData: "patientAgeInYears",
    yData: "weight",
    xSteps: 0.5,
    ySteps: 2,
    selected: false,
    zScore: "",
    show: true,
  },
  {
    id: 3,
    title: GROWTH_CHART_TILES_TITLES.BMI_FOR_AGE,
    subtitle: "Z-Score: ",
    yText: "BMI",
    xText: "Age",
    xData: "patientAgeInYears",
    yData: "bmi",
    xSteps: 0.5,
    ySteps: 2,
    selected: false,
    zScore: "",
    show: true,
  },
  {
    id: 4,
    title: GROWTH_CHART_TILES_TITLES.HC_FOR_AGE,
    subtitle: "Z-Score: ",
    yText: "Head Circumference",
    xText: "Age",
    xData: "patientAgeInYears",
    yData: "head_circumference",
    xSteps: 0.5,
    ySteps: 2,
    selected: false,
    zScore: "",
    show: true,
  },
  {
    id: 5,
    title: GROWTH_CHART_TILES_TITLES.MUAC_FOR_AGE,
    subtitle: "Z-Score: ",
    yText: "MUAC",
    xText: "Age",
    xData: "patientAgeInYears",
    yData: "muac",
    xSteps: 0.5,
    ySteps: 2,
    selected: false,
    zScore: "",
    show: true,
  },
  {
    id: 6,
    title: GROWTH_CHART_TILES_TITLES.LENGTH_FOR_AGE,
    subtitle: "Z-Score: ",
    yText: "Height/Length (cm)",
    xText: "Age",
    xData: "patientAgeInYears",
    yData: "height",
    xSteps: 0.5,
    ySteps: 2,
    selected: false,
    zScore: "",
    show: true,
  },
];

export const SAVE_TEMPLATE_HOVER_TEXT =
  "If you save this prescription as template, you will be able to reuse this ERx (fields - Chief Complaints, Drugs, Lab Findings, Suggested Investigations and Custom Sections) for your future appointments with other patients as well.";

export const ERX_LANGUAGE_LIST = [
  {
    id: 1,
    label: "English",
    value: "English",
    languageCode: "en",
    selected: true,
  },
  {
    id: 2,
    label: "Hindi",
    value: "Hindi",
    languageCode: "hi",
    selected: false,
  },
  {
    id: 3,
    label: "Marathi",
    value: "Marathi",
    languageCode: "mr",
    selected: false,
  },
  {
    id: 4,
    label: "Bengali",
    value: "Bengali",
    languageCode: "bn",
    selected: false,
  },
  {
    id: 5,
    label: "Gujarati",
    value: "Gujarati",
    languageCode: "gu",
    selected: false,
  },
  {
    id: 6,
    label: "Urdu",
    value: "Urdu",
    languageCode: "ur",
    selected: false,
  },
  {
    id: 7,
    label: "Kannada",
    value: "Kannada",
    languageCode: "kn",
    selected: false,
  },
  {
    id: 8,
    label: "Telugu",
    value: "Telugu",
    languageCode: "te",
    selected: false,
  },
  {
    id: 9,
    label: "Tamil",
    value: "Tamil",
    languageCode: "ta",
    selected: false,
  },
];

export const CUSTOM_BUTTON_STATUS = {
  SUCCESS: "success",
  LOADING: "loading",
  ERROR: "error",
  SAVE: "save",
};

export const ERX_LIST_HEADER_KEY = {
  SUGGESTED_INVESTIGATION: "suggested_investigation",
  DIAGNOSIS: "diagnosis",
  REPORT: "report",
  CHIEF_COMPLAINT: "chief_complaints",
  INSTRUCTION_AND_NOTES: "instructions_and_notes",
};

export const DRUG_QUANTITY_SYMBOLS = {
  0.33: "1⁄3",
  "0.50": "½",
  0.75: "¾",
};

// list for erx preview settings
export const ERX_PREVIEW_SETTINGS = [
  {
    sort: 1,
    title: "Follow up",
    name: "followUp",
    value: SELECTION_LIST_TITLES.PATIENT_FOLLOW_UP,
    customId: "erx-prescription-follow-up",
    alignment: "left",
    hideSectionInPreview: false,
    showLeftRightAlignment: true,
  },
  {
    sort: 2,
    title: "Vitals",
    name: "vitals",
    value: SELECTION_LIST_TITLES.VITALS,
    customId: "erx-prescription-vitals",
    alignment: "left",
    hideSectionInPreview: false,
    showLeftRightAlignment: true,
  },
  {
    sort: 3,
    title: "Chief Complaints",
    name: "chiefComplaints",
    value: SELECTION_LIST_TITLES.PATIENT_HISTORY,
    customId: "erx-prescription-chief-complaints",
    alignment: "left",
    hideSectionInPreview: false,
    showLeftRightAlignment: true,
  },
  {
    sort: 4,
    title: "Patient History",
    name: "medicalHistory",
    value: SELECTION_LIST_TITLES.PATIENT_HISTORY,
    customId: "erx-prescription-medical-history",
    alignment: "left",
    hideSectionInPreview: false,
    showLeftRightAlignment: true,
  },
  {
    sort: 5,
    title: "S. Investigation",
    name: "suggestedInvestigations",
    value: SELECTION_LIST_TITLES.SUGGESTED_INVESTIGATION,
    customId: "erx-prescription-suggested-investigations",
    alignment: "left",
    hideSectionInPreview: false,
    showLeftRightAlignment: true,
  },
  {
    sort: 6,
    title: "Instructions & Notes",
    name: "instructionsAndNotes",
    value: SELECTION_LIST_TITLES.SUGGESTED_INVESTIGATION,
    customId: "erx-prescription-instructions-and-notes",
    alignment: "left",
    hideSectionInPreview: false,
    showLeftRightAlignment: true,
  },
  {
    sort: 7,
    title: "Drugs",
    name: "drugs",
    value: "",
    customId: "erx-prescription-drugs",
    alignment: "right",
    hideSectionInPreview: false,
    showLeftRightAlignment: false,
  },
  {
    sort: 8,
    title: "Vaccine",
    name: "vaccine",
    value: "",
    customId: "erx-prescription-vaccine",
    alignment: "right",
    hideSectionInPreview: false,
    showLeftRightAlignment: false,
  },
  {
    sort: 9,
    title: "Diagnosis",
    name: "diagnosis",
    value: SELECTION_LIST_TITLES.DIAGNOSIS,
    customId: "erx-prescription-diagnosis",
    alignment: "right",
    hideSectionInPreview: false,
    showLeftRightAlignment: true,
  },
  {
    sort: 10,
    title: "Reports Examination",
    name: "reportsExamination",
    value: SELECTION_LIST_TITLES.PATIENT_EXAMINATION,
    customId: "erx-prescription-patient-reports-examination",
    alignment: "right",
    hideSectionInPreview: false,
    showLeftRightAlignment: true,
  },
  {
    sort: 11,
    title: "Growth Chart",
    name: "growthChart",
    value: "",
    customId: "erx-prescription-growth-chart",
    alignment: "right",
    hideSectionInPreview: true,
    showLeftRightAlignment: false,
  },
  {
    sort: 12,
    title: "Obstetric History",
    name: "obstetricHistory",
    value: SELECTION_LIST_TITLES.OBSTETRIC_HISTORY,
    customId: "erx-prescription-obstetric-history",
    alignment: "left",
    hideSectionInPreview: true,
    showLeftRightAlignment: true,
  },
  {
    sort: 13,
    title: "Custom Section 1",
    name: "customSection1",
    value: "",
    customId: "erx-prescription-custom-section1",
    alignment: "right",
    hideSectionInPreview: false,
    showLeftRightAlignment: false,
  },
  {
    sort: 14,
    title: "Custom Section 2",
    name: "customSection2",
    value: "",
    customId: "erx-prescription-custom-section2",
    alignment: "right",
    hideSectionInPreview: false,
    showLeftRightAlignment: false,
  },
  {
    sort: 15,
    title: "Custom Section 3",
    name: "customSection3",
    value: "",
    customId: "erx-prescription-custom-section3",
    alignment: "right",
    hideSectionInPreview: false,
    showLeftRightAlignment: false,
  },
  {
    sort: 16,
    title: "Obstetric Calculator",
    name: "obstetricCalculator",
    value: SELECTION_LIST_TITLES.OBSTETRIC_CALCULATOR,
    customId: "erx-prescription-obstetric-calculator",
    alignment: "left",
    hideSectionInPreview: false,
    showLeftRightAlignment: true,
  },
];

export const OBSTETRIC_HISTORY_INPUTS = {
  call_api: false,
  value: [
    {
      id: 1,
      title: "Gravidity",
      label: "gravidity",
      value: "",
      placeholder: "",
      type: "number",
    },
    {
      id: 2,
      title: "Parity",
      label: "parity",
      value: "",
      placeholder: "",
      type: "number",
    },
    {
      id: 3,
      title: "Living",
      label: "living",
      value: "",
      placeholder: "",
      type: "number",
    },
    {
      id: 4,
      title: "Abortion",
      label: "abortion",
      value: "",
      placeholder: "",
      type: "number",
    },
    {
      id: 5,
      title: "Ectopic",
      label: "ectopic",
      value: "",
      placeholder: "",
      type: "number",
    },
    {
      id: 6,
      title: "Death",
      label: "death",
      value: "",
      placeholder: "",
      type: "number",
    },
    {
      id: 7,
      title: "Obstetric Note",
      label: "obstetric_note",
      value: "",
      placeholder: "Enter your note here",
      type: "string",
    },
  ],
};

export const DEFAULT_OBSTETRIC_DETAILS = {
  lmpDate: "",
  eddDate: "",
  egaWeeks: "",
  egaDays: "",
  cycleLength: "28",
  note: "",
  callObstetricDetailsApi: false,
};

export const ALLOWED_SPECIALIZATIONS_FOR_OBSTETRIC_DETAILS = [
  "Gynecologist / Obstetrician",
  "Gynecologist & Infertility Specialist",
  "Gynecology & Fertility Specialist",
];

export const DEFAULT_API_LOADERS = [
  {
    api: "followUp",
    loader: false,
  },
  {
    api: "vitals",
    loader: false,
  },
  {
    api: "updatePrescription",
    loader: false,
  },
  {
    api: "userSettings",
    loader: false,
  },
  {
    api: "drugs",
    loader: false,
  },
  {
    api: "drugSearch",
    loader: false,
  },
];
